import { createApiFetch } from '@mbbe/config';
import { getAuthInstance } from './firebase';
import { adminSession } from './session';

async function getAuthToken(): Promise<string | null> {
  const auth = getAuthInstance();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export const apiFetch = createApiFetch({ getAuthToken, getSessionSignal: () => adminSession.current.signal });
